import {
  TextFieldProps,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import { useState } from "react";
import StripeInput from "./stripeInput";

type StripeElement =
  | typeof CardCvcElement
  | typeof CardExpiryElement
  | typeof CardNumberElement;

type StripeFieldProps<T extends StripeElement> = {
  inputProps?: React.ComponentProps<T>;
  labelErrorMessage?: string;
  onChange?: React.ComponentProps<T>["onChange"];
  stripeElement?: T;
} & Omit<TextFieldProps, "onChange" | "inputComponent" | "inputProps">;

export const StripeField = <T extends StripeElement>(
  props: StripeFieldProps<T>
) => {
  const {
    helperText,
    InputProps = {},
    inputProps,
    error,
    labelErrorMessage,
    stripeElement,
    ...other
  } = props;

  const [isLoading, setIsLoading] = useState(true);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {isLoading && (
        <CircularProgress
          sx={{ position: "absolute", zIndex: 1 }}
          size="38px"
          color="secondary"
        />
      )}
      <TextField
        data-dd-privacy="mask"
        style={{ opacity: `${isLoading ? "0.3" : "1"}` }}
        fullWidth
        error={error}
        slotProps={{
          input: {
            ...InputProps,
            inputProps: {
              ...inputProps,
              ...props.slotProps?.input,
              component: stripeElement,
              onReady: () => setIsLoading(false),
              disabled: isLoading,
              options: { disabled: isLoading },
            },
            inputComponent: StripeInput,
          },

          inputLabel: {
            ...props.slotProps?.inputLabel,
            shrink: true,
          },
        }}
        helperText={error ? labelErrorMessage : helperText}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        {...(other as any)}
      />
    </Box>
  );
};
